import request from '@/utils/request'
export function getOrderRefunds (val) {
  return request({
    url: '/api/oms/admin/order/refund/page',
    method: 'post',
    data: val.vo,
    params: {
      page: val.page,
      size: val.size,
      sort: 'dateCreated,desc'
    }
  })
}
export function getOrderRefund (val) {
  return request({
    url: `/api/oms/admin/order/refund/${val}`,
    method: 'get'
  })
}
// 提交申请扣费返款
export function refundAmount (orderNo, val) {
  return request({
    url: `/api/oms/admin/order/refund/apply/${orderNo}`,
    method: 'post', // 请求方式
    data: val
  })
}
export function refundExport (val) {
  return request({
    url: '/api/oms/admin/order/refund/export',
    method: 'post',
    data: val,
    responseType: 'blob'
  })
}
export function auditRefund (val) {
  return request({
    url: `/api/oms/admin/order/refund/audit/${val.auditStatus}/${val.refundId}`,
    method: 'put',
    params: {
      paymentChannel: val.paymentChannel
    }
  })
}

export function handleRefund (val) {
  return request({
    url: `/api/epay/admin/refund/handle/${val.action}/${val.refundId}`,
    method: 'get'
  })
}
